module.exports = __webpack_public_path__ + "img/code.1203b116.png";